import { Reducer } from "redux";

import { RationaleManagementTemplateNameResponse } from "../models/Api/RationaleManagement";
import { RationaleManagementTemplateNameDispatchTypes } from "../models/DispatchTypes/RationaleManagement";
import { RationaleManagementTemplateNameActionDispatchTypes } from "../constants/RationaleManagement";

const initialState: RationaleManagementTemplateNameResponse = {
  loading: true,
  response: [
    {
      rationaleTemplateId: -1,
      templateName: "",
      isActive: true,
      rationaleDecision: "",
      serviceRequestType: "",
      discipline: "",
      rationale: "",
      resourceDescription: "",
      userCreated: "",
    },
  ],
};

const RationaleManagmentNameReducer: Reducer<
  RationaleManagementTemplateNameResponse,
  RationaleManagementTemplateNameDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case RationaleManagementTemplateNameActionDispatchTypes.GET_RATIONALE_MANAGEMENT_TEMPLATE_NAME_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case RationaleManagementTemplateNameActionDispatchTypes.GET_RATIONALE_MANAGEMENT_TEMPLATE_NAME_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case RationaleManagementTemplateNameActionDispatchTypes.GET_RATIONALE_MANAGEMENT_TEMPLATE_NAME_ERROR: {
      return {
        response: initialState.response,
        loading: false,
      };
    }
  }
  return state;
};

export default RationaleManagmentNameReducer;
